import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/gltft-scan';

export class ScanService implements types.Handlers {
  private serviceEndpoint = '/scans';

  constructor(private axios: AxiosInstance) {}

  async createGltftScan({
    body,
  }: types.CreateGltftScanParameters): Promise<types.CreateGltftScanResponse> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/create`, {
        ...body,
      })
    ).data;
  }
  async delete({ body }: types.DeleteParameters): Promise<types.DeleteGLTFTScanResponse> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/delete`, {
        ...body,
      })
    ).data;
  }
  async getProject({ body }: types.GetProjectParameters): Promise<types.GetProjectResponse> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/project`, {
        ...body,
      })
    ).data;
  }
  getDescriptor(params: types.GetDescriptorParameters): Promise<types.GetDescriptorResponse> {
    throw new Error('Method not implemented.');
  }

  async fetchSignRequestParameters({
    path,
  }: types.FetchSignRequestParametersParameters): Promise<common.SignedRequestResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${path.scanId}/signed-request`)).data;
  }
}
